import React from 'react'

import './PageContentContainer.scss'

const PageContentContainer: React.FC = ({ children }) => {
  return <div className="PageContentContainer">{children}</div>
}

export default PageContentContainer
